/**
 * Centralized TanStack Query cache keys for consistent cache management
 *
 * All query keys follow a hierarchical structure:
 * - Root level: resource name (e.g., 'recipes', 'workspaces', 'categories')
 * - Nested: operation type (e.g., 'list', 'detail', 'workspace')
 * - Parameters: unknown required IDs or filters
 */

// Recipes query keys
export const recipeKeys = {
  all: ['recipes'] as const,
  lists: () => [...recipeKeys.all, 'list'] as const,
  detail: (id: string) => [...recipeKeys.all, 'detail', id] as const,
  workspace: (workspaceId: string) => [...recipeKeys.all, 'workspace', workspaceId] as const,
  standardUnits: () => [...recipeKeys.all, 'standard-units'] as const,
  search: (query: string) => [...recipeKeys.all, 'search', query] as const,
};

// Workspaces query keys
export const workspaceKeys = {
  all: ['workspaces'] as const,
  lists: () => [...workspaceKeys.all, 'list'] as const,
  detail: (id: string) => [...workspaceKeys.all, 'detail', id] as const,
  hydrate: (id: string) => [...workspaceKeys.all, 'hydrate', id] as const,
  members: (workspaceId: string) => [...workspaceKeys.all, 'members', workspaceId] as const,
  invites: (workspaceId: string) => [...workspaceKeys.all, 'invites', workspaceId] as const,
};

// Categories query keys
export const categoryKeys = {
  all: ['categories'] as const,
  workspace: (workspaceId: string) => [...categoryKeys.all, 'workspace', workspaceId] as const,
};

// Preferences query keys
export const preferenceKeys = {
  all: ['preferences'] as const,
  profile: () => [...preferenceKeys.all, 'profile'] as const,
};

// Export all keys for convenience
export const queryKeys = {
  recipes: recipeKeys,
  workspaces: workspaceKeys,
  categories: categoryKeys,
  preferences: preferenceKeys,
};

